<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4KKVLR/tc-custom/9781935149767.jpg?1728954405206" alt="This image is the cover for the book Immelmann"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Immelmann
      </h1>
      <p class="bookDescription body article font2">
        <b>A biography of one of Germany’s pioneers in aerial combat: “a great read” (<i>Internet Modeler</i>).</b><br/>  <br/> Max Immelmann was born in Dresden, the son of a container factory owner. When World War I started, Immelmann was recalled to active service, transferred to the Luftstreitkäfte, and sent for pilot training in November 1914. He was on his way to becoming a legendary flying ace.<br/>  <br/> Initially stationed in northern France as a reconnaissance aviator, he was shot down by a French pilot but managed to land safely behind German lines. He was decorated with the Iron Cross, Second Class for preserving his aircraft. Later in 1915, he became one of the first German fighter pilots, quickly building an impressive score of victories as he became known as The Eagle of Lille, <i>Der Adler von Lille</i>.<br/>  <br/> Known for the aerial combat maneuver that bears his name; for the use of a machine gun synchronized to fire forward through the propeller arc; and for his association with the Fokker Eindecker, Germany’s first fighter aircraft, Immelmann was the first pilot to be awarded the Pour le Mérite, Germany’s highest military honor—which became colloquially known as the “Blue Max” in the German Air Service. Along with Oswald Boelcke and other pilots, Immelmann was one of the main instigators of the Fokker Scourge, which inflicted heavy losses upon British and French aircrews during 1915. He was credited with fifteen victories—the final one coming on March 30, 1916.<br/>  <br/> This Casemate edition of Max Immelmann’s biography does not change a word from the original 1930 edition, but for the first time, reworks the original type and page layout to provide a beautiful and highly readable new treatment to this classic of aviation literature.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Frantz Immelmann
      </h2>
      
      <p class="authorDescription body article">Max Immelmann was born in Dresden, the son of a container factory owner. When World War I started, Immelmann was recalled to active service, transferred to the Luftstreitkäfte and was sent for pilot training in November 1914. He was initially stationed in northern France as a reconnaissance aviator. On June 3, 1915 he was shot down by a French pilot but managed to land safely behind German lines. He was decorated with the Iron Cross, Second Class for preserving his aircraft. Later in 1915, he became one of the first German fighter pilots, quickly building an impressive score of victories as he became known as The Eagle of Lille (Der Adler von Lille).</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Casemate
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7edffdc6